import { ethers } from "ethers";
import contracts from './contracts'
const localDatabaseName = "conet";
const apiv3_endpoint = `https://apiv3.conet.network/api/`;
const apiv4_endpoint = `https://apiv4.conet.network/api/`;
const payment_endpoint = `https://hooks.conet.network/api/`;
const XMLHttpRequestTimeout = 90 * 1000;
const conetRpc = "https://cancun-rpc.conet.network";
const mainChain_rpc = "https://mainnet-rpc.conet.network";
const paypal_endpoint = `https://centerapi.fx168api.com/`;
const _ethRpc = [
  "http://rpc.ankr.com/eth",
  "https://eth.llamarpc.com",
  "https://ethereum-rpc.publicnode.com",
  "https://eth-mainnet.public.blastapi.io"
];

const ethRpc = () => _ethRpc[Math.round(Math.random() * (_ethRpc.length - 1))];
const rewardWalletAddress = "GUq7PhyAUZko2mPhv3CupmdJKQ61LH8VyrdsRL25q7zg";
const stripe_pay_monthly = 'https://buy.stripe.com/test_9AQ16b6Du82p0Ja9AG?client_reference_id='
const stripe_pay_Annual ='https://buy.stripe.com/test_eVa2af5zqdmJ2Ri14b?client_reference_id='
const SilentPassOfficial = 'A8Vk2LsNqKktabs4xPY4YUmYxBoDqcTdxY5em4EQm8v1'


const conetProvider = new ethers.JsonRpcProvider(conetRpc);
let ethProvider = new ethers.JsonRpcProvider(ethRpc());
const conetDepinProvider = new ethers.JsonRpcProvider(mainChain_rpc);
const Solana_USDT = 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB'
const Solana_SOL = 'So11111111111111111111111111111111111111112'
const Solana_SP = 'Bzr4aEQEXrk7k8mbZffrQ9VzX6V3PAH4LvWKXkKppump'


const sGB_ReadOnly = new ethers.Contract(
	contracts.sGB.address,
	contracts.sGB.abi,
	conetDepinProvider
)

const sGB_Dashboard_ReadOnly = new ethers.Contract(
	contracts.sGB_Dashboard.address,
	contracts.sGB_Dashboard.abi,
	conetDepinProvider
)

const sGB_AirdropReadonly = new ethers.Contract(
	contracts.SGB_Airdrop.address,
	contracts.SGB_Airdrop.abi,
	conetDepinProvider
)



const changeRPC = () => {
	ethProvider = new ethers.JsonRpcProvider(ethRpc());
}


export {
  localDatabaseName,
  XMLHttpRequestTimeout,
  apiv3_endpoint,
  apiv4_endpoint,
  conetRpc,
  rewardWalletAddress,
  conetProvider,
  ethProvider,
  SilentPassOfficial,
  conetDepinProvider,
  changeRPC,
  stripe_pay_monthly,
  stripe_pay_Annual,
  payment_endpoint,
  paypal_endpoint,
  Solana_USDT,
  Solana_SOL,
  Solana_SP,
  sGB_ReadOnly,
  sGB_Dashboard_ReadOnly,
  sGB_AirdropReadonly
};
